<template>
    <div class="container-detail">
        <div class="detail-header-buttons">
            <v-btn @click="back" style="width: auto !important" class="button-accept">
                <v-icon>mdi-chevron-left</v-icon>
                Вернуться к списку акционеров
            </v-btn>

            <v-btn @click="goToEdit" style="width: auto !important" class="button-action">
                Редактировать
            </v-btn>
        </div>

        <div class="detail-main">
            <div class="detail-main-first-container" v-if="shareholder">
                <div class="first-container-box">
                    <div class="container-box-title">
                        ФИО
                    </div>
                    <div class="container-box-text">
                        {{ shareholder.fullName }}
                    </div>
                </div>
                <div class="first-container-box">
                    <div class="container-box-title">
                        Биография
                    </div>
                    <div class="container-box-text">
                        {{ shareholder.biography }}
                    </div>
                </div>





            </div>
            <div class="detail-main-second-container">
                <div class="second-container-box">
                    <div class="container-box-title">
                        Фотография акционера
                    </div>
                    <div class="container-box-text">
                        Нажмите на изображение, чтобы увидеть его в полном размере
                    </div>
                </div>

                <div>
                    <v-simple-table v-if="shareholder">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Формат
                                    </th>
                                    <th class="text-left">
                                        Место отображенния
                                    </th>
                                    <th class="text-left">
                                        Для смартфонов
                                    </th>
                                    <th class="text-left">
                                        Для планшетов
                                    </th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr style="height: 60px;">
                                    <td class="text-left">Фото</td>
                                    <td class="text-left">Отображается в списке «Состав» в разделе КСА</td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(shareholder.smartphoneImage)"
                                            v-if="shareholder.smartphoneImage" class="table-img"
                                            :src="shareholder.smartphoneImage">
                                    </td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(shareholder.tabletImage)" v-if="shareholder.tabletImage"
                                            class="table-img" :src="shareholder.tabletImage">
                                    </td>
                                </tr>




                            </tbody>
                        </template>
                    </v-simple-table>

                    <DialogImage v-model="dialogImg" :src="previewImage" />
                    <v-divider></v-divider>
                </div>

                <div class="second-container-box" style="margin-top: 32px" v-if="visibleActivities.length">
                    <div class="container-box-title">
                        Активности акционера
                    </div>
                </div>
                <div>
                    <v-simple-table v-if="visibleActivities.length">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left" v-for="(item, index) in visibleActivities" :key="index">
                                        {{ item.name }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td class="text-left" v-for="(item, index) in visibleActivities" :key="index">
                                        {{ item.value }}
                                    </td>

                                </tr>




                            </tbody>
                        </template>
                    </v-simple-table>


                    <v-divider></v-divider>
                </div>

            </div>


        </div>
    </div>
</template>
<script>

export default {

    data: () => ({
        shareholder: null,
        dialogImg: false,
        previewImage: null,
        hideNews: false,
        imageWidth: 0,

    }),
    computed: {
        visibleActivities() {
            return (this.shareholder?.activities || []).filter(activity => activity.name !== 'Количество мероприятий')
        },
    },
    methods: {
        openDialogImg(src) {
            this.previewImage = src
            this.dialogImg = true
        },
        back() {
            this.$router.push({ name: 'Shareholders' })
        },
        goToEdit() {
            this.$router.push({ name: 'EditShareholder', params: { id: this.$route.params.id } })
        },
        getShareholder() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/shareholder', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    shareholderId: this.$route.params.id
                }
            })
                .then(res => {
                    this.shareholder = res.data


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        }
    },
    created() {
        this.getShareholder()
    }
}
</script>
<style lang="scss" scoped>
.container-detail {
    box-sizing: border-box;
    padding: 40px !important;

    .detail-header-buttons {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
    }

    .detail-main {
        display: flex;
        justify-content: space-between;

        .detail-main-first-container {
            width: 48%;

            .first-container-box {

                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;

                }

                .container-box-text-list {
                    .container-box-text-list-item {
                        display: flex;
                        margin-bottom: 5px;

                        .list-item-subtitle {
                            font-size: 16px;
                            font-weight: 600;
                            color: #929292;
                            width: 200px;
                        }

                        .list-item-text {
                            font-size: 18px;
                            font-weight: 400;
                        }

                    }
                }
            }
        }

        .detail-main-second-container {
            width: 48%;

            .table-img {
                cursor: pointer;
                height: 38px;
                object-fit: contain;
            }

            .second-container-box {
                width: 100%;
                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;

                }
            }

        }

    }
}
</style>
